import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarDarkComponent } from '../../components/navbar/navbar.component';
import { HomeRoutingModule } from './home-routing.module';
import { ActivatedRoute } from '@angular/router';
import { UrlnavService } from '../../../../shared/urlnav.service';
import { BannerChildComponent } from '../../components/banner-child/banner-child.component';
import { BannerContactComponent } from '../../components/banner/banner-contact.component';
import { ContentIntroComponent } from '../../components/content-intro/content-intro.component';

@Component({
  selector: 'app-home-dark',
  standalone: true,
  imports: [CommonModule, NavbarDarkComponent, BannerChildComponent, BannerContactComponent, ContentIntroComponent],
  template: `
    <div class="container" style="margin-top: 120px;">
        <app-banner-child></app-banner-child>
        <app-banner-contact (about)="urlNav"></app-banner-contact>
        <app-content-intro></app-content-intro>
    </div>
  `,
  styles: [
    `*: {
      background-color: #302C42;
    }`
  ],
  encapsulation: ViewEncapsulation.None
})
export class HomeDarkComponent implements OnInit {
  url!: string | null;
  urlNav!: string;
  constructor(private activaed: ActivatedRoute, private urlnavService: UrlnavService) { }

  ngOnInit(): void {
   this.url =  this.activaed.snapshot.paramMap.get('dark')
   this.sendDataParams();
  }

  sendDataParams(){
    this.urlnavService.sendDataUrl(this.url)
  }


}
